// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2lXzo","additionalInfo":"AgreementModal_additionalInfo__oj6oQ"};